import {isNullOrUndefined} from "../../services/Validator";
import {kSystemIcons} from "../../constants/icons";

function SystemQuestionCardHeaderSubText({task}) {
    // Used in SystemQuestionCardHeader to display
    // level text in all mobile, tablet and desktop modes

    // BUILD
    if (isNullOrUndefined(task))
        return null
    return (
        <div className={"flex justify-start items-start space-x-4 text-greyLight5"}>
            <i className="material-icons text-[16px]">{kSystemIcons.task}</i>
            <span className={`font-medium text-[14px] sm:text-[16px] leading-none`}>
                {task}
            </span>
        </div>
    );
}

// EXPORT
export default SystemQuestionCardHeaderSubText
